// ==========================================
// 1. Image Gallery Functions
// ==========================================

function stkChangeImage(src, element) {
  document.getElementById("stkMainImg").src = src;
  document
    .querySelectorAll(".stk-hero-thumb")
    .forEach((thumb) => thumb.classList.remove("is-active"));
  element.classList.add("is-active");
}

function xChgImg(index, element, isAuto = false) {
  // If user interacted manually, stop the auto-slider to prevent conflicts
  if (!isAuto && window.stkAutoSlideInterval) {
    clearInterval(window.stkAutoSlideInterval);
    window.stkAutoSlideInterval = null;
  }

  const track = document.getElementById('xImgTrack');
  if (track) {
    const imgWidth = track.clientWidth;
    const currentIndex = Math.round(track.scrollLeft / imgWidth);
    const totalThumbs = document.querySelectorAll(".x-thumb").length;

    // Check if it's a looping jump (e.g., from last to first)
    const isLooping = Math.abs(index - currentIndex) > 1;

    track.scrollTo({ 
      left: imgWidth * index, 
      behavior: isLooping ? 'auto' : 'smooth' 
    });
  }

  document.querySelectorAll(".x-thumb").forEach((thumb) => thumb.classList.remove("is-active"));
  if (element) {
     element.classList.add("is-active");
  } else {
     const thumbs = document.querySelectorAll(".x-thumb");
     if (thumbs[index]) thumbs[index].classList.add("is-active");
  }
}

function xSlide(direction, isAuto = false) {
  const track = document.getElementById("xThumbsTrack");
  if (!track) return;

  const thumbs = Array.from(track.querySelectorAll('.x-thumb'));
  if (thumbs.length === 0) return;

  // Find the currently active thumbnail index
  let activeIndex = thumbs.findIndex(t => t.classList.contains('is-active'));
  if (activeIndex === -1) activeIndex = 0;

  // Calculate new index
  let newIndex = activeIndex + direction;
  if (newIndex < 0) newIndex = thumbs.length - 1;
  if (newIndex >= thumbs.length) newIndex = 0;

  const nextThumb = thumbs[newIndex];

  // Scroll the track so the new active thumb is visible
  const scrollPos = nextThumb.offsetLeft - track.offsetLeft - (track.clientWidth / 2) + (nextThumb.clientWidth / 2);
  track.scrollTo({
    left: scrollPos,
    behavior: 'smooth'
  });

  // Simulate a click on the thumbnail to change the main image and active state
  xChgImg(newIndex, nextThumb, isAuto);
}
// Add scroll listener to update thumb when main image is swiped manually
document.addEventListener('DOMContentLoaded', () => {
   const mainTrack = document.getElementById('xImgTrack');
   if(mainTrack) {
      let isScrolling;
      mainTrack.addEventListener('scroll', () => {
         window.clearTimeout(isScrolling);
         isScrolling = setTimeout(() => {
             const index = Math.round(mainTrack.scrollLeft / mainTrack.clientWidth);
             const thumbs = document.querySelectorAll(".x-thumb");
             
             thumbs.forEach((thumb, i) => {
                thumb.classList.toggle("is-active", i === index);
             });
             
             // Scroll thumb track into view
             const thumbTrack = document.getElementById("xThumbsTrack");
             const activeThumb = thumbs[index];
             if(thumbTrack && activeThumb) {
                const scrollPos = activeThumb.offsetLeft - thumbTrack.offsetLeft - (thumbTrack.clientWidth / 2) + (activeThumb.clientWidth / 2);
                thumbTrack.scrollTo({ left: scrollPos, behavior: 'smooth' });
             }
         }, 60); // wait for scroll snap to finish
      });
   }
});

// ==========================================
// 2. Quantity Input Functions
// ==========================================

function stkQtyChange(changeAmount) {
  const qtyInput = document.getElementById("stkQtyInput");
  let currentValue = parseInt(qtyInput.value) || 1;
  qtyInput.value = Math.max(1, currentValue + changeAmount);
}

function xQty(changeAmount) {
  const qtyInput = document.getElementById("xQtyIn");
  let currentValue = parseInt(qtyInput.value) || 1;
  qtyInput.value = Math.max(1, currentValue + changeAmount);
}

// ==========================================
// 3. UI & Interaction Functions
// ==========================================

function stkMove(element, directionMultiplier) {
  const productRail = element
    .closest(".stk-panel")
    .querySelector(".stk-product-rail");
  const scrollDistance =
    window.innerWidth <= 768
      ? productRail.clientWidth
      : 0.8 * productRail.clientWidth;
  productRail.scrollBy({
    left: scrollDistance * directionMultiplier,
    behavior: "smooth",
  });
}

function stkToggleFaq(element) {
  const faqItem = element.closest(".stk-faq-v1-item");
  const isActive = faqItem.classList.contains("is-active");

  document.querySelectorAll(".stk-faq-v1-item").forEach((item) => {
    item.classList.remove("is-active");
  });

  if (!isActive) {
    faqItem.classList.add("is-active");
  }
}

// ==========================================
// 4. Shopify AJAX Cart Function
// ==========================================

function flyToCart(sourceElement) {
  const mainImg = document.getElementById("img-0") || document.getElementById("xMainImg");
  const cartIcon = document.querySelector("cart-icon") || document.querySelector("[data-testid='cart-drawer-trigger']") || document.querySelector(".header-actions__cart-icon") || document.querySelector("#cart-icon-bubble");

  if (!sourceElement || !cartIcon) return;

  const sourceRect = sourceElement.getBoundingClientRect();
  const cartIconRect = cartIcon.getBoundingClientRect();

  const flyingBox = document.createElement("div");
  flyingBox.style.position = "fixed";
  flyingBox.style.left = sourceRect.left + (sourceRect.width / 2) - 25 + "px";
  flyingBox.style.top = sourceRect.top + (sourceRect.height / 2) - 25 + "px";
  flyingBox.style.width = "50px";
  flyingBox.style.height = "50px";
  
  if (mainImg) {
    flyingBox.style.backgroundImage = `url(${mainImg.src})`;
    flyingBox.style.backgroundSize = "cover";
    flyingBox.style.backgroundPosition = "center";
  } else {
    flyingBox.style.backgroundColor = "#ff6a00";
  }
  
  flyingBox.style.borderRadius = "8px";
  flyingBox.style.zIndex = "99999";
  flyingBox.style.pointerEvents = "none";
  flyingBox.style.boxShadow = "0 10px 20px rgba(0,0,0,0.3)";

  flyingBox.style.transform = "translate(0px, 0px) scale(1)";
  flyingBox.style.transition = "transform 0.4s cubic-bezier(0.25, 1, 0.5, 1), opacity 0.4s ease-in";
  
  document.body.appendChild(flyingBox);

  const moveX = cartIconRect.left - (sourceRect.left + (sourceRect.width / 2) - 25) + (cartIconRect.width / 2) - 25;
  const moveY = cartIconRect.top - (sourceRect.top + (sourceRect.height / 2) - 25) + (cartIconRect.height / 2) - 25;

  flyingBox.getBoundingClientRect();

  flyingBox.style.transform = `translate(${moveX}px, ${moveY}px) scale(0.2)`;
  flyingBox.style.opacity = "0.3";

  setTimeout(() => {
    flyingBox.remove();
  }, 400);
}

function xRelSlide(direction) {
  const track = document.getElementById("xRelTrack");
  if (!track) return;
  const cardWidth = track.querySelector('.stk-card') ? track.querySelector('.stk-card').clientWidth : 300;
  track.scrollBy({
    left: direction * (cardWidth + 20),
    behavior: 'smooth'
  });
}

function stkAddToCart(event, formElement) {
  event.preventDefault();
  const btn = formElement.querySelector(".stk-add-btn") || formElement.querySelector(".x-addb");
  const originalBtnHTML = btn.innerHTML;

  btn.innerHTML = '<span class="stk-bs-btn-text">ADDING...</span>';
  
  const formData = new FormData(formElement);

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    body: formData,
  })
    .then((response) => response.json())
    .then((cartItem) => {
      btn.innerHTML = '<span class="stk-bs-btn-text">ADDED!</span><span class="stk-bs-btn-icon">✓</span>';
      setTimeout(() => {
        btn.innerHTML = originalBtnHTML;
      }, 2000);

      flyToCart(btn);

      // First, get the exact real-time cart count from Shopify's backend
      fetch(window.Shopify.routes.root + "cart.js", { cache: "no-store" })
        .then(res => res.json())
        .then(cartData => {
            // Delay by 500ms so Shopify backend cache fully processes the addition before we fetch the fresh HTML for the drawer
            setTimeout(() => {
                fetch(window.location.pathname + "?_t=" + Date.now(), { cache: "no-store" })
                  .then(res => res.text())
                  .then(html => {
                     const doc = new DOMParser().parseFromString(html, "text/html");

                     // Completely replace the drawer to perfectly sync the products inside
                     const oldDrawer = document.querySelector("cart-drawer-component, cart-drawer");
                     const newDrawer = doc.querySelector("cart-drawer-component, cart-drawer");
                     if (oldDrawer && newDrawer) {
                         oldDrawer.replaceWith(newDrawer);
                     }

                     // Trigger global events just in case
                     document.documentElement.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
                     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

                     // Open the drawer conditionally if the total price is >= 20000 (200 RS)
                     if (cartData.total_price >= 20000) {
                         setTimeout(() => {
                             const freshDrawer = document.querySelector("cart-drawer-component, cart-drawer");
                             if (freshDrawer && typeof freshDrawer.open === 'function') {
                                 freshDrawer.open(document.querySelector("cart-icon"));
                             } else {
                                 const trigger = document.querySelector("[data-testid='cart-drawer-trigger']") || document.querySelector("cart-icon button") || document.querySelector("cart-icon") || document.querySelector(".header-actions__cart-icon").closest('button');
                                 if (trigger) trigger.click();
                             }
                         }, 100);
                     }
                  });
            }, 500);
        });
    })
    .catch((error) => {
      console.error("Error adding to cart:", error);
      btn.innerHTML = originalBtnHTML;
    });
}

// ==========================================
// 5. Global DOMContentLoaded Initializer
// ==========================================

document.addEventListener("DOMContentLoaded", function () {
  // Auto-scroll the main image gallery every 3 seconds
  window.stkAutoSlideInterval = setInterval(() => {
    xSlide(1, true); // true indicates it's an auto-slide
  }, 3000);

  // Pause auto-scroll when user touches the image wrapper
  const imgTrack = document.getElementById("xImgTrack");
  if (imgTrack) {
    imgTrack.addEventListener("touchstart", () => {
      if (window.stkAutoSlideInterval) {
        clearInterval(window.stkAutoSlideInterval);
        window.stkAutoSlideInterval = null;
      }
    }, { passive: true });
  }

  // --- A. STK Tabs Logic ---
  const tabTriggers = document.querySelectorAll(".stk-tab-trigger");
  const panels = document.querySelectorAll(".stk-panel");
  const scrollContainer = document.querySelector(".stk-nav-scroll-container");

  if (tabTriggers.length > 0) {
    tabTriggers.forEach((tab) => {
      tab.addEventListener("click", (event) => {
        event.preventDefault();

        tabTriggers.forEach((t) => t.classList.remove("is-active"));
        panels.forEach((p) => p.classList.remove("is-active"));
        tab.classList.add("is-active");

        const targetPanel = document.getElementById(tab.dataset.target);
        if (targetPanel) {
          targetPanel.classList.add("is-active");
        }

        if (scrollContainer) {
          const containerWidth = scrollContainer.offsetWidth;
          const tabLeftOffset = tab.offsetLeft;
          const tabWidth = tab.offsetWidth;
          scrollContainer.scrollTo({
            left: tabLeftOffset - containerWidth / 2 + tabWidth / 2,
            behavior: "smooth",
          });
        }
      });
    });
  }

  // --- B. STK Image Slider Logic ---
  setInterval(() => {
    document.querySelectorAll(".stk-img-slider").forEach((slider) => {
      const slides = slider.querySelectorAll(".stk-slide-img");
      if (slides.length > 1) {
        let currentIndex = Array.from(slides).findIndex((slide) =>
          slide.classList.contains("is-visible"),
        );
        if (currentIndex === -1) currentIndex = 0;

        slides[currentIndex].classList.remove("is-visible");
        slides[currentIndex].style.position = "absolute";

        let nextIndex = (currentIndex + 1) % slides.length;
        slides[nextIndex].classList.add("is-visible");
        slides[nextIndex].style.position = "relative";
      }
    });
  }, 3000);

  // --- C. X Product Option Selector Logic ---
  const optionSelect = document.getElementById("xOptSel");
  const productIdInput = document.querySelector('.x-form input[name="id"]');

  if (optionSelect && productIdInput) {
    optionSelect.addEventListener("change", function () {
      productIdInput.value = this.value;
    });
  }
});

// ==========================================
// 6. AJAX Collection Filtering
// ==========================================

// Dropdown toggle logic
document.addEventListener('click', function(e) {
  const isDropdownBtn = e.target.closest('.stk-dropdown-btn');
  if (isDropdownBtn) {
    const dropdown = isDropdownBtn.closest('.stk-filter-dropdown');
    const isActive = dropdown.classList.contains('is-active');
    
    // Close all other dropdowns
    document.querySelectorAll('.stk-filter-dropdown.is-active').forEach(d => {
      d.classList.remove('is-active');
    });

    if (!isActive) {
      dropdown.classList.add('is-active');
    }
  } else if (!e.target.closest('.stk-dropdown-content')) {
    // Close all if clicking outside
    document.querySelectorAll('.stk-filter-dropdown.is-active').forEach(d => {
      d.classList.remove('is-active');
    });
  }
});

function stkFilterAjax(urlOverride) {
  const form = document.getElementById('CollectionFiltersForm');
  if (!form && !urlOverride) return;

  let fetchUrl = '';
  if (urlOverride) {
    fetchUrl = urlOverride;
  } else {
    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData);
    fetchUrl = `${window.location.pathname}?${searchParams.toString()}`;
  }

  const gridContainer = document.getElementById('ProductGridContainer');
  if (gridContainer) gridContainer.style.opacity = '0.5';

  fetch(fetchUrl)
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Update URL without refresh
      window.history.pushState({path: fetchUrl}, '', fetchUrl);

      // Replace Grid
      const newGrid = doc.getElementById('ProductGridContainer');
      if (newGrid && gridContainer) {
        gridContainer.innerHTML = newGrid.innerHTML;
        gridContainer.style.opacity = '1';
      }

      // Replace Pagination
      const newPagination = doc.getElementById('ProductPagination');
      const currentPagination = document.getElementById('ProductPagination');
      if (newPagination && currentPagination) {
        currentPagination.innerHTML = newPagination.innerHTML;
      }

      // Replace Count
      const newCount = doc.getElementById('ProductCount');
      const currentCount = document.getElementById('ProductCount');
      if (newCount && currentCount) {
        currentCount.innerHTML = newCount.innerHTML;
      }
    })
    .catch(error => {
      console.error('Error fetching filtered products:', error);
      if (gridContainer) gridContainer.style.opacity = '1';
    });
}

function stkClearFilters(url) {
  stkFilterAjax(url);
  // Also uncheck all checkboxes visually
  const form = document.getElementById('CollectionFiltersForm');
  if(form) {
    form.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.checked = false);
  }
}

// Handle browser back/forward buttons
window.addEventListener('popstate', function(e) {
  if (e.state && e.state.path) {
    stkFilterAjax(e.state.path);
  } else {
    window.location.reload();
  }
});
